<template>
  <div class="home">
    <!-- Quick presentation -->
    <div class="home_quick_presentation_container" id="presentation">
      <b-container class="home_quick_presentation">
        <h1 class="pull-left home_quick_presentation_title">
          Coaching Télétravail
          <font-awesome-icon icon="chalkboard-teacher" />
        </h1>
        <hr />
        <b-row>
          <b-col lg="5" xl="5" sm="12" class="home_quick_presentation_img">
            <b-img
              rounded="0"
              thumbnail
              fluid
              :src="require('../assets/img/teletravail_coach.jpg')"
              alt="coach formation télétravail collegues"
            ></b-img>
          </b-col>

          <b-col lg="7" xl="7" sm="12" class="home_quick_presentation_text">
            <b-jumbotron
              fluid
              lead="Le télétravail, ce n'est pas naturel..."
              class="home_quick_presentation_text_jumb"
              bg-variant="light"
            >
              <p v-html="quickPresentation"></p>
              <div class="home_quick_presentation_coursebutton">
                <b-button
                  @click="goToFormationDetails()"
                  squared
                  size="lg"
                  variant="info"
                  href="/formation"
                  >Détails de la formation/coaching</b-button
                >
              </div>
            </b-jumbotron>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- Témoignages -->
    <div class="home_reviews_container">
      <b-container class="home_reviews">
        <b-row>
          <b-col cols="12">
            <!-- Reviews component -->
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- Introduction aux formations -->
    <div class="home_courses_pres_container" id="formations">
      <b-container class="home_courses_pres">
        <h1 class="home_courses-title" style="text-align:left">
          <font-awesome-icon icon="book" />
          La formation
        </h1>
        <hr class="white-hr" />
        <b-jumbotron style="padding: 2rem" fluid>
          <p class="home_courses_pres_text" v-html="coursesPresentation"></p>
          <b-img
              rounded="0"
              thumbnail
              fluid
              :src="require('../assets/img/remote-here-to-stay.png')"
              alt="coach formation télétravail collegues"
              class="home_heretostay_img"
            ></b-img>
        </b-jumbotron>

        <!-- Buttons -->
        <b-row>
          <!-- Pour les entreprises -->

            
          
          <b-col lg="12" xl="12" sm="12">
            
            <b-button
              @click="goToFormationDetails()"
              squared
              size="lg"
              variant="info"
              href="/formation"
              >Détails de la formation/coaching</b-button
            >
            <!-- <p class="home_courses_pres_list">
              <font-awesome-icon icon="arrow-right"/> Outils d'organisation (frameworks, apps, ...)
              <br />
              <font-awesome-icon icon="arrow-right"/> Gestion du stress
              <br />
              <font-awesome-icon icon="arrow-right"/> Culture d'entreprise
              <br />
              <font-awesome-icon icon="arrow-right"/> Espace de travail
              <br />
              <font-awesome-icon icon="arrow-right"/> Séparation vie pro / perso
              <br />
              <font-awesome-icon icon="arrow-right"/> ...
            </p> -->
          </b-col>
          <!-- Pour les indépendants -->
          <!-- <b-col lg="6" xl="6" sm="12">
            <b-button
            squared
            size="lg"
            variant="light"
            disabled=""
            >Pour les indépendants</b-button>
          </b-col> -->
        </b-row>
      </b-container>

      
    </div>

    <!-- Contact form -->
    <ContactForm id="contact" />
    <WhoAmI id="whoami" />
  </div>
</template>

<script>
import { quickPresentation, coursesPresentation } from "@/data/texts";
import ContactForm from "@/components/ContactForm.vue";
import WhoAmI from "@/components/WhoAmI.vue";

export default {
  name: "Home",
  components: {
    ContactForm,
    WhoAmI,
  },
  methods: {
    goToFormationDetails() {
      this.$ga.event("home-page", "click", "formationDetails", new Date().getTime());
    },
  },
  data() {
    return {
      quickPresentation: quickPresentation,
      coursesPresentation: coursesPresentation,
    };
  },
};
</script>
